<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <img :src="logo" style="max-width:50%;" class="mx-auto"/>
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Restablecer Contraseña</h4>
                  <p class="mb-0">Introduzca su nueva contraseña.</p>
                </div>
                <div class="card-body">
                  <form @submit.prevent="resetPassword" >

                    <div class="mb-3">
                        <div class="input-group input-group-lg">
                            <input
                                type="email"
                                placeholder="Email"
                                name="email"
                                class="form-control"
                                :value="email"
                                disabled
                            />
                        </div>
                    </div>

                    <div class="mb-3">
                        <div class="input-group input-group-lg">
                            <input
                                :type="newPasswordFieldType"
                                placeholder="Nueva Contraseña"
                                name="new_password"
                                class="form-control"
                                v-model="newPassword"
                                style="border-right: none;"
                                required
                            />
                            <span
                                class="input-group-text password-toggle"
                                @click="togglePasswordVisibility('new')"
                            >
                                <i :class="newPasswordFieldType === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                            </span>
                        </div>
                    </div>

                    <div class="mb-3">
                        <div class="input-group input-group-lg">
                            <input
                                :type="confirmPasswordFieldType"
                                placeholder="Confirmar Contraseña"
                                name="confirm_password"
                                class="form-control"
                                v-model="confirmPassword"
                                style="border-right: none;"
                                required
                            />
                            <span
                                class="input-group-text password-toggle"
                                @click="togglePasswordVisibility('confirm')"
                            >
                                <i :class="confirmPasswordFieldType === 'password' ? 'fas fa-eye' : 'fas fa-eye-slash'"></i>
                            </span>
                        </div>
                    </div>

                    <div class="text-center">
                      <argon-button
                        type="submit"
                        class="mt-4"
                        color="success"
                        fullWidth
                        size="lg"
                      >Restablecer y Acceder</argon-button>
                    </div>
                  </form>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
// NOTA: Se ha quitado la importación de ArgonInput
import ArgonButton from "@/components/ArgonButton.vue";
import axios from 'axios';
import Swal from 'sweetalert2';
import logo from "@/assets/img/logo.png";
import { useRoute } from 'vue-router';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "PasswordReset",
  components: {
    // ArgonInput ya no se usa en el template
    ArgonButton,
  },
  data() {
    return {
      logo,
      newPassword: null,
      confirmPassword: null,
      // 🛑 NUEVOS ESTADOS DE VISIBILIDAD
      newPasswordFieldType: 'password',
      confirmPasswordFieldType: 'password',
    }
  },
  // Usamos setup() para obtener parámetros de la URL
  setup() {
    const route = useRoute();
    const token = route.query.token || null;
    const email = route.query.email ? decodeURIComponent(route.query.email) : null;

    return { token, email };
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");

    if (!this.token || !this.email) {
      Swal.fire({
        title: 'Error de Enlace',
        text: 'El enlace de restablecimiento es inválido o ha expirado.',
        icon: 'error',
        confirmButtonColor: '#bf4f51',
      }).then(() => {
        this.$router.push('/login');
      });
    }
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
  methods: {
    // 🛑 NUEVO MÉTODO: Alterna la visibilidad
    togglePasswordVisibility(field) {
        if (field === 'new') {
            this.newPasswordFieldType =
                this.newPasswordFieldType === 'password' ? 'text' : 'password';
        } else if (field === 'confirm') {
            this.confirmPasswordFieldType =
                this.confirmPasswordFieldType === 'password' ? 'text' : 'password';
        }
    },

    // Función para iniciar sesión (se mantiene)
    login(credentials) {
      // ... (código de login) ...
      let self = this;
      axios.post(self.$store.state.apiURL + 'login', credentials)
        .then((result) => {
          localStorage.setItem('userId', result.data.id);
          localStorage.setItem('userEmail', result.data.email);
          localStorage.setItem('userFullName', result.data.full_name);
          localStorage.setItem('userName', result.data.username);
          localStorage.setItem('userLevel', result.data.role_id);
          localStorage.setItem('accessToken', result.data.token);
          localStorage.setItem('companyId', result.data.company);

          Swal.fire({
              title: '¡Sesión Iniciada!',
              text: 'Tu contraseña ha sido restablecida e iniciaste sesión.',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500
          });
          self.$router.push('/');
        })
        .catch((err) => {
          console.error("Fallo de inicio de sesión automático:", err);
          Swal.fire({
            title: 'Error de Sesión',
            text: 'Contraseña restablecida, pero fallo al iniciar sesión. Intenta iniciar sesión manualmente.',
            icon: 'warning',
            confirmButtonColor: '#bf4f51',
          }).then(() => {
            self.$router.push('/signin');
          });
        });
    },

    // Función principal para restablecer la contraseña (se mantiene)
    resetPassword() {
      let self = this;

      if (this.newPassword !== this.confirmPassword) {
        Swal.fire({
          title: 'Error',
          text: 'Las contraseñas no coinciden.',
          icon: 'warning',
          confirmButtonColor: '#bf4f51',
        });
        return;
      }

      if (!this.newPassword || this.newPassword.length < 6) {
        Swal.fire({
          title: 'Error',
          text: 'La contraseña debe tener al menos 6 caracteres.',
          icon: 'warning',
          confirmButtonColor: '#bf4f51',
        });
        return;
      }

      const resetData = {
        token: this.token,
        email: this.email,
        new_password: this.newPassword,
      };

      axios.post(self.$store.state.apiURL + 'password/reset', resetData)
        .then(() => {
          const loginCredentials = {
            username: this.email,
            password: this.newPassword,
          };
          this.login(loginCredentials);
        })
        .catch((err) => {
          console.error("Fallo al restablecer la contraseña:", err);
          let errorMessage = 'Ha ocurrido un error al intentar restablecer la contraseña. El enlace puede ser inválido o haber expirado.';

          if (err.response && err.response.data && err.response.data.message) {
             errorMessage = err.response.data.message;
          }

          Swal.fire({
            title: 'Fallo de Restablecimiento',
            text: errorMessage,
            icon: 'error',
            confirmButtonColor: '#bf4f51',
          });
        });
    }
  }
};
</script>

<style scoped>
/* Estilos para el input group del ojo */
.password-toggle {
    cursor: pointer;
    background-color: white;
    border-left: none;
    border-color: #dee2e6; /* Color del borde de Bootstrap */
    padding-right: 15px;
}
</style>